import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Particles from "react-particles";
import { loadConfettiPreset } from "tsparticles-preset-confetti";
import { useColors } from '../../theme/ColorModeContext';
import DiscordCTA from '../../shared/DiscordCTA';
import EmailOptInPrompt from '../../shared/EmailOptInPrompt';

interface ModalCompleteProps {
    open: boolean,
    token: string,
    setOpen: React.Dispatch<React.SetStateAction<any>>
}

const QUOTES = [
    "Congratulations on conquering the challenge! Your determination and resilience have paved the way for success.",
    "In the face of adversity, you stood tall and emerged victorious. Cheers to your triumphant conquest of the challenge!",
    "Hats off to you for tackling the challenge head-on and emerging as a true champion. Your success is truly well-deserved!",
    "A challenge met with courage, dedication, and a dash of brilliance: congratulations on turning obstacles into stepping stones!",
    "Your ability to navigate and overcome challenges is truly admirable. Congratulations on mastering the art of triumph!",
    "Bravo! You've not only faced the challenge but also conquered it with flying colors. Your achievement is an inspiration to us all.",
    "Kudos on your remarkable accomplishment! You've proven that challenges are merely opportunities in disguise.",
    "Congratulations on unlocking the door to success by overcoming the challenge before you. Your victory is well-earned and celebrated!",
    "A standing ovation for your outstanding achievement! Your perseverance in the face of challenges is truly commendable.",
    "To conquer a challenge is no small feat, and you've done it with grace and tenacity. Congratulations on your well-deserved success!",
];

const ModalComplete = (props: ModalCompleteProps) => {
    const colors = useColors();
    const open = props.open;
    const setOpen = props.setOpen;
    const token = props.token;

    const customInit = async (engine: any) => {
      await loadConfettiPreset(engine);
    };

    return (
        <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
           <>
            <Particles options={{
              preset: "confetti",
              background: { opacity: 0 },
            }} init={customInit} />

            <Box sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '500px',
                maxWidth: '90vw',
                backgroundColor: colors.bg.secondary,
                border: `1px solid ${colors.border.accent}`,
                borderRadius: '8px',
                overflow: 'hidden',
                boxShadow: `0 0 40px rgba(185, 28, 28, 0.12)`,
            }}>
              <Typography
                id="modal-modal-title"
                variant="h4"
                component="h1"
                sx={{
                    padding: '24px',
                    textAlign: 'center',
                    fontFamily: '"Orbitron", sans-serif',
                    fontWeight: 700,
                    background: colors.gradient.primary,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    borderBottom: `1px solid ${colors.border.subtle}`,
                }}
              >
                Congratulations!
              </Typography>
              <Box sx={{ padding: '24px' }}>
                <Typography variant="body1" sx={{
                    color: colors.text.secondary,
                    lineHeight: 1.7,
                    textAlign: 'center',
                }}>
                    {QUOTES[(Math.random() * QUOTES.length) | 0]}
                </Typography>
                {/*
                  * Right after a solve is when "tell me about the next one" is
                  * most wanted. Renders nothing for anyone who already answered
                  * (subscribed, unsubscribed, or dismissed it anywhere).
                  */}
                <EmailOptInPrompt
                    token={token}
                    placement="challenge-complete"
                    headline="Want the next one?"
                    body="Get an email when new challenges and chain tracks go live. A couple of times a month at most."
                    sx={{ marginTop: '20px', marginBottom: 0 }}
                />
                <DiscordCTA variant="reward" placement="challenge-complete" sx={{ mt: '20px' }} />
              </Box>
            </Box>
            </>
        </Modal>
    );
}

export default ModalComplete;
